import { apiGet } from "../baseApi";
import { setCampusData } from "service/mapper";

export const getList = async ({params, config = {}}) => {
  try {
    const response = await apiGet("_campus", params, null, config );
    return {
      ...response,
      rowData: (Array.isArray(response.data.campuses) ? response.data.campuses : []).map((el) => setCampusData(el)),
    };
  } catch (error) {
    return Promise.reject(error);
  }
};
